const hasClubhousePermission = (userClubPermissions, permissionsNeeded, user, clubhouseData) => {
  // console.log('userClubPermissions:', userClubPermissions);
  // console.log('permissionsNeeded:', permissionsNeeded);
  // console.log('user:', user);
  // console.log('clubhouseData:', clubhouseData);

  if (!userClubPermissions || !permissionsNeeded || !clubhouseData) {
    return false;
  }

  const currentClubUUID = clubhouseData?.uuid ? clubhouseData.uuid : clubhouseData.id;
  // console.log('currentClubUUID:', currentClubUUID);

  const check = userClubPermissions.find((clubPerm) => {
    const clubPermID = clubPerm?.club_uuid ?? clubPerm?.id;
    return clubPermID === currentClubUUID;
  });
  // console.log('check:', check);

  const matchedPermissions =
    check?.permissions?.filter((permissionTheyHave) =>
      // console.log('permissionTheyHave:', permissionTheyHave);
      {
        return permissionsNeeded.includes(permissionTheyHave);
      }
    ) ?? [];
  // console.log('matchedPermissions:', matchedPermissions);

  function UserException(message) {
    this.message = message;
    this.name = 'UserException';
  }
  if (!matchedPermissions?.length) {
    return false;
    // throw new Error(`You do not have sufficient permissions: ${permissionsNeeded}
    //   You Have: ${user.permissions}`);
    // throw new UserException(`You do not have sufficient permissions:
    //   You Need: ${permissionsNeeded}
    //   You Have: ${user.permissions}`);
  }

  return true;
};

const hasPermission = (userClubPermissions = [], permissionsNeeded = []) => {
  if (!userClubPermissions || !permissionsNeeded) {
    return false;
  }
  const matchedPermissions = userClubPermissions?.filter((permissionTheyHave) => {
    return permissionsNeeded.includes(permissionTheyHave);
  });
  function UserException(message) {
    this.message = message;
    this.name = 'UserException';
  }
  if (!matchedPermissions?.length) {
    return false;
    // throw new Error(`You do not have sufficient permissions: ${permissionsNeeded}
    //   You Have: ${user.permissions}`);
    // throw new UserException(`You do not have sufficient permissions:
    //   You Need: ${permissionsNeeded}
    //   You Have: ${user.permissions}`);
  }

  return true;
};

export { hasClubhousePermission as default, hasPermission };
